import { DragDropContext, DropResult } from "@hello-pangea/dnd";
import React from "react";

import { ConfirmModal } from "../../../overlay/modals/ConfirmModal";
import { viewModels } from "../defines";
import { useDataMan } from "../hooks/useDataMan";
import { DataManConfirmDisclosureData } from "../types/actions";
import { useCloseAnimationTimeout } from "@gettactic/helpers/src/hooks/useCloseAnimationTimeout";
import { UseDisclosureReturn } from "@gettactic/helpers";

export const DataManBody: React.FC = () => {
  const dataMan = useDataMan();
  const viewObject = dataMan.viewMode
    ? viewModels[dataMan.viewMode]
    : undefined;

  const content = viewObject?.Wrapper
    ? React.createElement(viewObject?.Wrapper)
    : undefined;

  const isConfirmModalOpen = dataMan.openConfirmationModal?.isOpen ?? false;
  const { isVisible: isConfirmModalVisible } = useCloseAnimationTimeout(
    isConfirmModalOpen,
    { animationDuration: 200 }
  );

  // Preserve modal data during close animation
  const confirmModalDataRef =
    React.useRef<UseDisclosureReturn<DataManConfirmDisclosureData> | null>(
      null
    );
  if (
    dataMan.openConfirmationModal?.isOpen &&
    dataMan.openConfirmationModal?.data
  ) {
    confirmModalDataRef.current = dataMan.openConfirmationModal;
  }
  const modalData = isConfirmModalOpen
    ? dataMan.openConfirmationModal
    : confirmModalDataRef.current;

  if (!viewObject) return null; // TODO Add some sort of visual error message

  const confirmationModal = isConfirmModalVisible ? (
    <ConfirmModal
      isOpen={isConfirmModalOpen}
      onOpenChange={(isOpen) => {
        modalData?.onOpenChange(isOpen);
        if (!isOpen) {
          modalData?.data?.onClose?.();
        }
      }}
      onConfirm={modalData?.data?.onConfirm}
      onCancel={modalData?.data?.onCancel}
      message={modalData?.data?.message}
      title={modalData?.data?.title}
      confirmProps={modalData?.data?.confirmButtonProps}
      cancelProps={modalData?.data?.cancelButtonProps}
    />
  ) : null;

  if (dataMan.hasSortableDataColumns) {
    const handleDragEnd = (result: DropResult) => {
      if (!result.destination) return;
      dataMan.moveRecord(
        [result.draggableId],
        String(result.source.droppableId).replace("content-table-", ""),
        String(result.destination.droppableId).replace("content-table-", ""),
        result.source.index,
        result.destination.index
      );
    };

    const handleDragUpdate = () => {};

    return (
      <>
        <DragDropContext
          onDragEnd={handleDragEnd}
          onDragUpdate={handleDragUpdate}
        >
          {content}
        </DragDropContext>
        {confirmationModal}
      </>
    );
  }

  return (
    <>
      {content}
      {confirmationModal}
    </>
  );
};
